import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "th_consent";

export const openCookieBanner = () => window.dispatchEvent(new Event("th-cookies"));

export default function CookieBanner() {
  const [open, setOpen] = useState(() => { try { return !localStorage.getItem(KEY); } catch { return true; } });
  useEffect(() => {
    const show = () => setOpen(true);
    window.addEventListener("th-cookies", show);
    return () => { window.removeEventListener("th-cookies", show); };
  }, []);
  const choose = (v) => {
    try { localStorage.setItem(KEY, v); } catch { /* stockage indisponible */ }
    window.gtag?.("consent", "update", { analytics_storage: v });
    setOpen(false);
  };
  if (!open) return null;
  return (
    <div className="fixed inset-x-3 bottom-20 z-[70] mx-auto max-w-xl rounded-2xl border bg-white p-5 shadow-2xl md:bottom-5" role="dialog" aria-label="Cookies" data-testid="cookie-banner">
      <p className="flex items-center gap-2 font-display font-black"><Cookie className="h-5 w-5 text-[#C06014]" /> Votre vie privée</p>
      <p className="mt-2 text-sm text-muted-foreground">Avec votre accord, nous utilisons Google Analytics pour mesurer l'audience du site et l'améliorer. Aucune publicité. <Link to="/politique-confidentialite" className="font-semibold text-[#C06014] underline">En savoir plus</Link></p>
      <div className="mt-4 flex flex-wrap justify-end gap-2">
        <button onClick={() => choose("denied")} className="rounded-full border px-5 py-2 text-sm font-bold hover:bg-[#F5F3E9]" data-testid="cookie-refuse">Refuser</button>
        <button onClick={() => choose("granted")} className="rounded-full bg-[#C06014] px-5 py-2 text-sm font-bold text-white" data-testid="cookie-accept">Accepter</button>
      </div>
    </div>
  );
}
